import React from 'react';
import './InterpreterChip.css';

/**
 * Interpreter chip — small floating action button that appears next to the
 * mic in active voice mode. Mirrors RN Dashboard line 2001:
 *
 *   {isFeatureEnabled('interpreter', false) && audioChat.isListening && (
 *     <Animated.View style={interpreterBtnAnimatedStyle}>...
 *
 * Render gate must be both conditions; CSS handles the fade/slide-in
 * (interpreterBtnTranslateX 6→0, interpreterBtnOpacity 0→1 in 220ms).
 */
const InterpreterChip: React.FC<{ onClick?: () => void }> = ({ onClick }) => {
  return (
    <button
      type="button"
      className="wg-interpreter-chip"
      onClick={onClick}
      aria-label="Open interpreter"
    >
      <TranslateIcon />
    </button>
  );
};

function TranslateIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <path d="M3 5h10" />
      <path d="M8 3v2" />
      <path d="M5 8a8 8 0 0 0 8 8" />
      <path d="M11 8a8 8 0 0 1-8 8" />
      <path d="m13 21 4-9 4 9" />
      <path d="M14.5 18h5" />
    </svg>
  );
}

export default InterpreterChip;
